var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3 19.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 .5-.5h7.721c.372 0 .718.18.932.476l.074.117.751 1.355h6.872c.593 0 1.08.449 1.143 1.025l.007.125v8.752a1.15 1.15 0 0 1-1.025 1.143L17.85 13h-7.373a1.15 1.15 0 0 1-.932-.476l-.074-.117-.751-1.356H3zM3 9.051h6.221c.372 0 .718.18.932.477l.074.116.751 1.356H17V3.948h-6.523a1.15 1.15 0 0 1-.932-.476l-.074-.116L8.72 2H3z"
})));
export default SvgIconFlag;